import React from 'react';
import { Navbar, Container } from 'react-bootstrap';

const Nav = ({ onMenuToggle }) => {
  return (
    <Navbar className="shadow-sm">
      <Container fluid>
        <Navbar.Brand href="/">
          <i className="fas fa-chart-line me-2"></i>
          <span className="fw-bold">
            Trader Analysis
          </span>
        </Navbar.Brand>
        
        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={onMenuToggle}>
          <i className="fas fa-bars"></i>
        </button>
      </Container>
    </Navbar>
  );
};

export default Nav;
